import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import { useDistributorProvider } from '../Distributor.Hooks';

export default function DistributorFilters() {
  const { listApi } = useDistributorProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body}
      onFilter={(newFilers) => listApi.execute(newFilers)}
      onReset={listApi.reset}
    />
  );
}
